import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { SelectModule } from 'primeng/select';
import { ConjuntoActivoServicio } from '@nucleo/conjunto/conjunto-activo-servicio';
import { traducciones } from '@nucleo/i18n/traduccion-util';
import { TEXTOS_CRUD } from '../../i18n/crud-textos';

/** Elige el conjunto (condominio) con el que se trabaja; lo usan casi todas las pantallas de Comunia. */
@Component({
  selector: 'app-selector-conjunto',
  imports: [
    FormsModule,
    IconFieldModule,
    InputIconModule,
    SelectModule,
  ],
  templateUrl: './selector-conjunto.html',
  styleUrl: './selector-conjunto.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectorConjunto implements OnInit {
  protected readonly servicio = inject(ConjuntoActivoServicio);
  protected readonly t = traducciones(TEXTOS_CRUD);

  ngOnInit(): void {
    if (this.servicio.conjuntos().length === 0 && !this.servicio.cargando()) {
      this.servicio.cargar();
    }
  }
}
